import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_ASSIGNEES_REQUEST = 'FETCH_ASSIGNEES_REQUEST';
export const FETCH_ASSIGNEES_SUCCESS = 'FETCH_ASSIGNEES_SUCCESS';
export const FETCH_ASSIGNEES_FAILURE = 'FETCH_ASSIGNEES_FAILURE';

export const assigneesSchema = new schema.Entity('assignees', {}, { idAttribute: 'oid' });

/**
 * Fetch contract assignees.
 *
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchAssignees = () =>
  createAction({
    endpoint: `${window.config.apiUrl}/assignees`,
    method: 'GET',
    types: [
      { type: FETCH_ASSIGNEES_REQUEST },
      {
        type: FETCH_ASSIGNEES_SUCCESS,
        payload: (action, state, res) => handleResponse([assigneesSchema], action, state, res),
      },
      { type: FETCH_ASSIGNEES_FAILURE, payload: handleError },
    ],
  });
